module.exports = __webpack_public_path__ + "img/newBackground.e38532d7.svg";